<!-- 导出出入记录 -->
<template>
<el-form label-width="100px">
    <el-row>
        <el-col :xs="24" :sm="20">
            <el-form-item label-width="100px">
                <el-tag type="danger">{{msg('单次导出最多只能选择1000条库存数据')}}</el-tag>
            </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="20">
            <el-form-item :label="msg('选择变更时间')" label-width="100px">
                <el-date-picker  v-model="created"  type="daterange"  :range-separator="msg('至')" 
                    value-format="yyyy-MM-dd"
                    end-placeholder=""
                    size="small"
                >
                </el-date-picker>
            </el-form-item>
        </el-col>
    </el-row>
    <div style="text-align:center; margin-top: 15px;">
        <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('导出')}}</span></el-button>
        <el-button  size="mini" v-on:click="$emit('close-dg')">{{msg('取消')}}</el-button>
    </div>

</el-form> 
</template>

<script>
export default {
  name: 'ExpressSorting',
  data(){
    return{
        created:[],
    }
  },
  props: {
  },
  computed:{
  },
  mounted: function(){
  },
  methods:{
      init(){
          this.created = [];
      },
      onSubmit(){
        if(!this.created){
            this.$message(this.msg('请选择时间'));
            return;
        }

        this.$emit("close-dg",this.created);
    },
  }
}
</script>

<style scoped lang="scss">

</style>
